import Parse from 'parse/dist/parse.min';

const PARSE_APPLICATION_ID = import.meta.env.VITE_PARSE_APPLICATION_ID;
const PARSE_JAVASCRIPT_KEY = import.meta.env.VITE_PARSE_JAVASCRIPT_KEY;
export const PARSE_SERVER_URL = import.meta.env.VITE_PARSE_SERVER_URL;

Parse.initialize(PARSE_APPLICATION_ID, PARSE_JAVASCRIPT_KEY);
Parse.serverURL = PARSE_SERVER_URL;

// The SDK retries every failed request 5x with backoff by default. When
// the backend is unreachable that turns one dead call into ~5 hanging
// XHRs and seconds of UI lag (e.g. the auth check in the route guard).
// Cap at a single attempt so failures surface immediately.
Parse.CoreManager.set('REQUEST_ATTEMPT_LIMIT', 1);

export default Parse;
